module.exports = __webpack_public_path__ + "img/tab02.cd04d0fb.png";